import { combineReducers } from 'redux';
import { createScopedReducer } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    AVAILABILITY_INTERVAL_REPORT_INIT_STARTED,
    AVAILABILITY_INTERVAL_REPORT_INIT_SUCCEEDED,
    AVAILABILITY_INTERVAL_REPORT_INIT_FAILED,
    AVAILABILITY_DATE_REPORT_INIT_STARTED,
    AVAILABILITY_DATE_REPORT_INIT_SUCCEEDED,
    AVAILABILITY_DATE_REPORT_INIT_FAILED,
    AVAILABILITY_HEATMAP_INIT_STARTED,
    AVAILABILITY_HEATMAP_INIT_SUCCEEDED,
    AVAILABILITY_HEATMAP_INIT_FAILED,
} from '../actionTypes';
import { ReportMode } from '../types';

const createScopedMetaReducer = (actionTypes: { STARTED: string; SUCCEEDED: string; FAILED: string }) =>
    createScopedReducer(META_STATE_SUCCEEDED, {
        ...createEntityAsyncMetaHandlers(actionTypes),
    });

const intervalMetaReducer = createScopedMetaReducer({
    STARTED: AVAILABILITY_INTERVAL_REPORT_INIT_STARTED,
    SUCCEEDED: AVAILABILITY_INTERVAL_REPORT_INIT_SUCCEEDED,
    FAILED: AVAILABILITY_INTERVAL_REPORT_INIT_FAILED,
});

const dateMetaReducer = createScopedMetaReducer({
    STARTED: AVAILABILITY_DATE_REPORT_INIT_STARTED,
    SUCCEEDED: AVAILABILITY_DATE_REPORT_INIT_SUCCEEDED,
    FAILED: AVAILABILITY_DATE_REPORT_INIT_FAILED,
});

const heatmapMetaReducer = createScopedMetaReducer({
    STARTED: AVAILABILITY_HEATMAP_INIT_STARTED,
    SUCCEEDED: AVAILABILITY_HEATMAP_INIT_SUCCEEDED,
    FAILED: AVAILABILITY_HEATMAP_INIT_FAILED,
});

const metaReducer = combineReducers({
    [ReportMode.Interval]: intervalMetaReducer,
    [ReportMode.Date]: dateMetaReducer,
    [ReportMode.OccupancyHeatmap]: heatmapMetaReducer,
    [ReportMode.AvailabilityHeatmap]: heatmapMetaReducer,
});

export default metaReducer;
